import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApi } from 'model/Api';
import { Contractor } from 'model/Contractor';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import FormContent from 'component/part/FormContent';
import OperationTrigger from 'component/part/OperationTrigger';
import H2 from 'component/part/H2';

const initialContractor: Contractor = {
  id: 0,
  name: '',
};

const style = {
  form: {
    ...generalStyle.form,
    ['& input']: {
      maxWidth: '32rem',
    },
  },
};

const ContractorEdit: React.FC = () => {
  const api = useApi();
  const navigate = useNavigate();
  const urlParams = useParams<{ id: string }>();
  const contractorId = parseInt(urlParams.id || '');
  const [contractor, setContractor] = useState<Contractor>(initialContractor);

  const onChangeContractor = <T extends keyof Contractor>(key: T, value: Contractor[T]) => {
    setContractor({ ...contractor, [key]: value });
  };

  const onSubmit = async () => {
    const result = await api.contractor.update(contractor);

    return result.ok && !!result.data;
  };

  useEffect(() => {
    (async () => {
      if (contractorId) {
        const contractorResponse = await api.contractor.get(contractorId);
        if (contractorResponse) {
          setContractor(contractorResponse);
        } else {
          setContractor({ ...contractor, id: contractorId });
        }
      }
    })();
  }, [contractorId]);

  return <Layout>
    <BackLink link='/contractor/list' label='元請情報一覧'></BackLink>
    <H2>{contractorId ? '元請情報編集' : '元請情報登録'}</H2>
    <div css={style.form}>
      <FormContent label='元請名'>
        <input type="text" value={contractor.name} onChange={(e) => onChangeContractor('name', e.target.value)} />
      </FormContent>
      <OperationTrigger
        onSubmit={onSubmit}
        onOk={() => navigate('/contractor/list')}
        buttonText={contractorId ? '更新' : '登録'}
        objectType='contractor'
        operationType={contractorId ? 'edit' : 'create'}
      />
    </div>
  </Layout>;
};

export default ContractorEdit;
